export const DepartmentCreateSceneTranslation = {
  fi: {
    DepartmentCreateScene: {
      title: 'Luo uusi osasto',
    },
  },
};
